import React from 'react';
import { InputNumber as AntInputNumber } from 'antd';
import PropTypes from 'prop-types';
import styles from './styles.less';

const propsByVersion = {
  default: {
    size: 'middle',
    className: styles.default,
  },
};

const InputNumber = ({ className, version, ...rest }) => {
  const { className: propsClassName = '', ...props } = propsByVersion[version];

  return <AntInputNumber {...props} className={`${propsClassName} ${className}`} {...rest} />;
};

InputNumber.propTypes = {
  version: PropTypes.oneOf(['default']),
  className: PropTypes.string,
};

InputNumber.defaultProps = {
  version: 'default',
  className: '',
};

export default InputNumber;
